import { FontSizes, FontWeights, IStyle } from '@fluentui/react';
import { IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface IStatCardStyles {
  card: IStyle;
  header: IStyle;
  title: IStyle;
  mainStat: IStyle;
  mainNumber: IStyle;
  mainLabel: IStyle;
  subStats: IStyle;
  subStat: IStyle;
  subNumber: IStyle;
  subLabel: IStyle;
  divider: IStyle;
  errorOverlay: IStyle;
  errorContent: IStyle;
  errorIcon: IStyle;
  overlayText: IStyle;
  noDataText: IStyle;
}

export const statCardStylesDefault = (theme: IH2OTheme): Partial<IStatCardStyles> => ({
  card: {
    position: 'relative',
    border: '1px solid #eaeaea',
    borderRadius: 8,
    padding: Sizes.padding,
    width: '100%',
  },
  header: {
    marginBottom: 20,
  },
  title: {
    margin: 0,
    fontSize: FontSizes.large,
    fontWeight: FontWeights.bold,
    color: theme.palette?.gray700,
  },
  mainStat: {
    textAlign: 'center',
    marginBottom: '1.5rem',
    paddingBottom: '1rem',
    borderBottom: '1px solid #edebe9',
  },
  mainNumber: {
    display: 'block',
    fontSize: FontSizes.xxLarge,
    fontWeight: FontWeights.bold,
    color: theme.palette?.primary800,
    marginBottom: 4,
  },
  mainLabel: {
    display: 'block',
    fontSize: FontSizes.medium,
    color: theme.semanticColors?.textSecondary,
    fontWeight: FontWeights.semibold,
  },
  subStats: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subStat: {
    textAlign: 'center',
    flex: 1,
  },
  subNumber: {
    display: 'block',
    fontSize: FontSizes.xLarge,
    fontWeight: FontWeights.bold,
    color: theme.palette?.gray900,
    marginBottom: 2,
  },
  subLabel: {
    display: 'block',
    fontSize: 12,
    color: theme.semanticColors?.textSecondary,
    fontWeight: FontWeights.semilight,
  },
  divider: {
    width: 1,
    height: 40,
    backgroundColor: '#edebe9',
    margin: '0 16px',
  },
  errorOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  errorContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  errorIcon: {
    fontSize: '2rem',
    marginBottom: '0.5rem',
  },
  overlayText: {
    fontSize: '18px',
    color: theme.palette?.red400,
    fontWeight: 600,
  },
  noDataText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.gray500,
  },
});
